// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trend-chart {
  position: relative;
  padding: 8px 0 4px;
}

.trend-legend {
  display: flex;
  gap: 16px;
  margin-bottom: 10px;
}

.trend-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--an-text-muted);
}

.trend-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
}

.trend-svg {
  width: 100%;
  height: 220px;
  display: block;
}

.trend-tooltip {
  position: absolute;
  top: 8px;
  transform: translateX(-50%);
  background: #0b0b0b;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  z-index: 10;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);
}

.trend-tooltip-swatch {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  display: inline-block;
  margin-right: 4px;
}

.trend-empty {
  padding: 32px 0;
  text-align: center;
  color: var(--an-text-faint);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/TrendLineChart.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".trend-chart {\n  position: relative;\n  padding: 8px 0 4px;\n}\n\n.trend-legend {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 10px;\n}\n\n.trend-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--an-text-muted);\n}\n\n.trend-legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.trend-svg {\n  width: 100%;\n  height: 220px;\n  display: block;\n}\n\n.trend-tooltip {\n  position: absolute;\n  top: 8px;\n  transform: translateX(-50%);\n  background: #0b0b0b;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  white-space: nowrap;\n  z-index: 10;\n  pointer-events: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);\n}\n\n.trend-tooltip-swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  display: inline-block;\n  margin-right: 4px;\n}\n\n.trend-empty {\n  padding: 32px 0;\n  text-align: center;\n  color: var(--an-text-faint);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
